type DailyShareTextInput = {
  type: "daily"
  score: number
  gameType: string
  date: string
}

type OtherShareTextInput = {
  type: "standard" | "timed" | "versus"
  score: number
  gameType: string
  difficulty?: string
}

type ShareTextInput = DailyShareTextInput | OtherShareTextInput

const modeNames = {
  standard: "Classic",
  timed: "Timed Mode",
  versus: "Versus Mode",
} satisfies Record<OtherShareTextInput["type"], string>

export function buildShareText(input: ShareTextInput): string {
  if (input.type === "daily") {
    return `Play Higher Lower — Daily Challenge — ${input.gameType} — ${input.date} — Score: ${input.score}\nhttps://playhigherlower.com/daily`
  }

  const difficulty = input.difficulty ? ` (${input.difficulty})` : ""
  return `I scored ${input.score} on ${modeNames[input.type]}${difficulty} - ${input.gameType}! Play at https://playhigherlower.com`
}
